import { render } from "./LoadData.vue?vue&type=template&id=b6438e90"
import script from "./LoadData.vue?vue&type=script&lang=js"
export * from "./LoadData.vue?vue&type=script&lang=js"

import exportComponent from "/builds/dock/research/autocbm/autocbm-ui/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__